import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Public marketing copy only: do not change user-post Open Graph metadata.
export const useLandingMetadata = (page = null) => {
  const { t } = useTranslation('landing');
  const title = page ? t(`metadata.titles.${page}`) : null;
  const description = t('metadata.description');
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;
    const entries = [['name', 'description'], ['property', 'og:description'], ['name', 'twitter:description']];
    const restore = entries.map(([attribute, value]) => {
      let node = document.head.querySelector(`meta[${attribute}="${value}"]`);
      const existed = !!node;
      const previous = node?.getAttribute('content');
      if (!node) {
        node = document.createElement('meta');
        node.setAttribute(attribute, value);
        document.head.appendChild(node);
      }
      node.setAttribute('content', description);
      return () => {
        if (!existed) node.remove();
        else if (previous === null) node.removeAttribute('content');
        else node.setAttribute('content', previous);
      };
    });
    return () => {
      if (title && document.title === title) document.title = previousTitle;
      restore.forEach((cleanup) => cleanup());
    };
  }, [title, description]);
};